import React, { useEffect, useState } from "react";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { CiCalendar } from "react-icons/ci";
import { CiSearch } from "react-icons/ci";

import {
  Paper,
  Typography,
  TextField,
  Box,
  Card,
  Stack,
} from "@mui/material";

import {
  ATTENDANCE_PIECHART,
  LOCATION,
  VERIFY_HOLIDAY,
} from "../../../api-calls/api-urls";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import holidayImage from "../../../assets/images/holidayImage.png";
import { useDispatch, useSelector } from "react-redux";
import { saveLocationList } from "../../../Redux/actions/location-action";
import { getLanguagedataFunction } from "../../../utilities/language";
import moment from "moment";
import AlertBox from "../../../components/AlertBox";
import DashBoardBoxContainer from "./DashBoardBoxContainer";
import TeamDetails from "./TeamDetails";
import { getTeamDetails } from "../../../utilities/commonFunctions";

const Dashboard = () => {
  const [date, setDate] = useState(new Date());

  const [holiday, setHoliday] = useState();
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState("");
  const [filteredTeams, setFilteredTeams] = useState([]);
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const {
    locationList,
    locationFilteredStatus,
    locationFilterTime,
    locationFilterMembers,
    viewAll,
  } = useSelector((state) => state.location);
  const { sortName, current_user } = useSelector(
    (state) => state.allUsers
  );
  const [currectTeam, setCurrentTeam] = useState(null); // or [] or {} depending on your logic
  const [searchValue, setSearchValue] = useState("");
  const [attendance, setAttendance] = useState();

  const ln = useSelector((state) => state.allUsers.language_json);
  const [teamList, setTeamList] = useState([]);
  React.useEffect(() => {
    if (!ln) {
      getLanguagedataFunction(dispatch);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const attendance = {
  //   total: 15,
  //   present: 13,
  //   absent: 2,
  // };

  useEffect(() => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAttendanceData = async (selectedDate) => {
    try {
      const dateParam = moment(selectedDate || new Date()).format("YYYY-MM-DD");
      const { data } = await authApi.get(
        `${ATTENDANCE_PIECHART}?start_date=${dateParam}&end_date=${dateParam}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      console.log(data);
      setAttendance(data);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        console.log(error.response);
        setShowAlert(true);
        setError(error.response.data.message);
      }
    }
  };



  const getLocationData = async (userEntry) => {
    if (userInfo && userInfo.user_type === "team_leader") {
      try {
        const { data } = await authApi.post(
          `${LOCATION}?sort=${sortName}&view_all=${false}`,
          userEntry,
          {
            headers: { Authorization: getAuthorizationHeader() },
          }
        );
        dispatch(saveLocationList(data));
      } catch (error) {
        setShowAlert(true);
        setError(error.response?.data?.message || "Something went wrong");
      }
    }
  };
  useEffect(() => {
    VerifyHoliday();
  }, []);

  const VerifyHoliday = async () => {
    try {
      const { data } = await authApi.get(
        `${VERIFY_HOLIDAY}/${moment(new Date()).format("YYYY-MM-DD")}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      setHoliday(data.holiday);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (showAlert) {
      const timeout = setTimeout(() => {
        setShowAlert(false);
      }, 3000); // Change the duration (in milliseconds) as per your requirement

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [showAlert]);

  useEffect(() => {
    const filterArray = {
      status: locationFilteredStatus,
      sortby: locationFilterTime,
      members: locationFilterMembers,
    };
    console.log(filterArray);
    getLocationData(filterArray);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    !locationList,
    locationFilteredStatus,
    locationFilterTime,
    locationFilterMembers,
    locationFilterMembers,
    viewAll,
    sortName,
  ]);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const getTeamDetail = async (date, search) => {
    try {
      const data = await getTeamDetails(
        moment(new Date(date)).format("YYYY-MM-DD")
      );
      setTeamList(data);
      setFilteredTeams(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getTeamDetail(date);
    getAttendanceData(date);
  }, [date]);
  useEffect(() => {
    if (!searchValue) {
      // If search empty, show full list
      setFilteredTeams(teamList);
    } else {
      // Filter by team name (assuming each team object has a 'name' property)
      const filtered = teamList.filter((team) =>
        team.team_name.toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredTeams(filtered);
    }
  }, [searchValue, teamList]);

  // We store the formatted string for customInput display
  return (
    <Box sx={{ width: '95%', margin: '0 auto', mt: 5 }}>
      <Typography variant="h4" sx={{ 
        fontWeight: 700, 
        mb: 3,
        background: 'linear-gradient(135deg, hsl(217, 91%, 60%) 0%, hsl(260, 91%, 60%) 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }}>
        {`Hi, ${current_user?.user_id?.name}!`}
      </Typography>

      {holiday ? (
        <Paper sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center',
          height: '70vh',
          textAlign: 'center',
          p: 4
        }}>
          <img src={holidayImage} alt="holiday" style={{ maxWidth: '400px', height: 'auto', marginBottom: '24px' }} />
          <Typography variant="h5" color="text.secondary">
            No data to show because you have marked this day as holiday.
          </Typography>
        </Paper>
      ) : (
        <Box>
          {ln && (
            <Stack spacing={3}>
              <Box sx={{ display: 'flex', gap: 3, flexDirection: { xs: 'column', lg: 'row' } }}>
                <Card sx={{ flex: 1, p: 3, display: 'flex', flexDirection: 'column' }}>
                  <DashBoardBoxContainer locationList={locationList} />
                </Card>

                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 3 }}>
                  <Card sx={{ p: 3, display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                      <Typography variant="h6" sx={{ textTransform: 'capitalize' }}>
                        {ln.attendance}
                      </Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          value={date ? dayjs(date) : null}
                          onChange={(newValue) => setDate(newValue?.toDate())}
                          format="DD/MM/YYYY"
                          slots={{ openPickerIcon: CiCalendar }}
                          slotProps={{
                            textField: {
                              size: 'small',
                              sx: { 
                                width: 150,
                                '& .MuiIconButton-root': {
                                  color: '#0a1f41',
                                  opacity: 1
                                },
                                '& svg': {
                                  color: '#0a1f41',
                                  fill: '#0a1f41',
                                  stroke: '#0a1f41'
                                }
                              }
                            }
                          }}
                        />
                      </LocalizationProvider>
                    </Box>

                    {attendance && (
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', flexGrow: 1 }}>
                        <Box sx={{ position: 'relative', width: 140, height: 140 }}>
                          <svg viewBox="0 0 44 44" style={{ transform: 'rotate(-90deg)' }}>
                            <circle cx="22" cy="22" r="16" fill="transparent" stroke="hsl(220, 13%, 91%)" strokeWidth="6" />
                            <circle
                              cx="22"
                              cy="22"
                              r="16"
                              fill="transparent"
                              stroke="hsl(217, 91%, 60%)"
                              strokeWidth="6"
                              strokeDasharray={`${(attendance.present / attendance.total) * 100} ${100 - (attendance.present / attendance.total) * 100}`}
                              strokeDashoffset="0"
                            />
                            <circle
                              cx="22"
                              cy="22"
                              r="16"
                              fill="transparent"
                              stroke="hsl(0, 84%, 60%)"
                              strokeWidth="6"
                              strokeDasharray={`${(attendance.absent / attendance.total) * 100} ${100 - (attendance.absent / attendance.total) * 100}`}
                              strokeDashoffset={`${-(attendance.present / attendance.total) * 100}`}
                            />
                          </svg>
                          <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            textAlign: 'center'
                          }}>
                            <Typography variant="h6" sx={{ lineHeight: 1 }}>{attendance.total}</Typography>
                            <Typography variant="caption" color="text.secondary">{ln.total}</Typography>
                          </Box>
                        </Box>

                        <Stack spacing={1}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: 'hsl(217, 91%, 60%)' }} />
                            <Typography variant="body1" sx={{ fontWeight: 600 }}>{attendance.present}</Typography>
                            <Typography variant="body2">{ln.present}</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: 'hsl(0, 84%, 60%)' }} />
                            <Typography variant="body1" sx={{ fontWeight: 600 }}>{attendance.absent}</Typography>
                            <Typography variant="body2">{ln.absent}</Typography>
                          </Box>
                        </Stack>
                      </Box>
                    )}
                  </Card>

                  <Card sx={{ p: 3 }}>
                    <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>
                      All teams
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Search teams"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      variant="outlined"
                      size="small"
                      sx={{ mb: 3 }}
                      InputProps={{
                        startAdornment: <CiSearch size={20} style={{ marginRight: 8, color: 'gray' }} />,
                      }}
                    />
                    
                    <Stack spacing={2}>
                      {filteredTeams?.length > 0 ? (
                        filteredTeams.map((item, index) => (
                          <TeamDetails
                            key={item._id || index}
                            setCurrentTeam={setCurrentTeam}
                            index={index}
                            currectTeam={currectTeam}
                            details={item}
                          />
                        ))
                      ) : (
                        <Typography color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                          No teams found matching your search.
                        </Typography>
                      )}
                    </Stack>
                  </Card>
                </Box>
              </Box>
            </Stack>
          )}

          {showAlert && error && (
            <AlertBox type="error" message={error} stateName={setShowAlert} />
          )}
        </Box>
      )}
    </Box>
  );
};

export default Dashboard;
